import styled from 'styled-components';

const Section = styled.section`
  align-content: flex-start;
  display: flex;
  justify-content: flex-start;
  padding: 40px 0;
  @media (max-width: ${({ breakpoint }) => `${breakpoint}px`}) {
    display: block;
    padding: 20px 0;
  }

  & + & {
    border-top: 1px solid #d6d6d6;
  }
`;

// type ASProps = {
//   /** Fine tune the breakpoints for each view */
//   breakpoint?: number,
//   children: React.ReactNode,
//   id?: string,
// };

/**
 * Annotated sections group the content of the page into distinct sections that are only loosely related.
 * This layout makes it easier to scan the page for a particular section.
 * Use this layout for settings screens. Don’t use this layout when members need to navigate to more than one
 * section to complete their task.
 */
export const AnnotatedSection = ({ breakpoint = 1024, children, id, ...props }) => (
  <Section breakpoint={breakpoint} id={id} {...props}>
    {children}
  </Section>
);
